import React, { useEffect, useRef } from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import Tiff from "tiff.js";
import PermissionWrapper from "../../scenes/Setting/PermissionWrapper";

export default function DocumentPreview({
  preview,
  height = 450,
  onReindex,
  showReindex = false,
  reindexing = false,
  showSplit = false,
  onSplit,
  category
}) {
  const canvasRef = useRef(null);

  useEffect(() => {
      if (!preview || !preview.type?.includes("tif") || !preview.url) return;

      fetch(preview.url)
          .then(r => r.arrayBuffer())
          .then(buffer => {
              const tiff = new Tiff({ buffer });
              // tiff.setDirectory(selectedPage - 1);
              const canvas = tiff.toCanvas();

              if (canvasRef.current) {
                  canvasRef.current.innerHTML = "";
                  canvasRef.current.appendChild(canvas);
              }
          });

      // fetch(preview.url)
      //   .then((res) => res.arrayBuffer())
      //   .then((buffer) => {
      //     const tiff = new Tiff({ buffer });
      //     const canvas = tiff.toCanvas();

      //     if (!canvas) throw new Error("Failed to render TIFF");

      //     canvas.style.width = "100%";
      //     canvas.style.height = "auto";
      //     canvas.style.display = "block";

      //     canvasRef.current.innerHTML = "";
      //     canvasRef.current.appendChild(canvas);
          
      //   })
      //   .catch((err) => {
      //     console.error("TIFF error:", err);
      //     canvasRef.current.innerHTML = "TIFF preview failed";
      //   });
    }, [preview]);



  if (!preview) {
    return (
      <Typography variant="body2" color="text.secondary">
        Select a document to preview
      </Typography>
    );
  }

  const src = preview.file
    ? URL.createObjectURL(preview.file)
    : preview.url;

  return (
    <Box>
      {/* 🔹 Header */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={1}
      >
        <Typography variant="subtitle1">Document Preview</Typography>
        <PermissionWrapper category={category} level="READ_WRITE">
        <Stack direction="row" spacing={1}>
          {showSplit && onSplit && (
            <Button
              size="small"
              variant="outlined"
              onClick={() => onSplit(preview)}
            >
              Split
            </Button>
          )}

          {showReindex && onReindex && (
            <Button
              size="small"
              variant="outlined"
              disabled={reindexing}
              onClick={() => onReindex(preview)}
            >
              {reindexing ? "Re-indexing..." : "Re-Index"}
            </Button>
          )}
        </Stack>
        </PermissionWrapper>

      </Stack>

      {/* IMAGE (except TIFF) */}
      {preview.type?.startsWith("image/") &&
        !preview.type.includes("tif") && (
          <Box
            component="img"
            src={src}
            sx={{ maxWidth: "100%", maxHeight: height }}
          />
        )}

      {/* PDF */}
      {preview.type?.includes("pdf") && (
        <iframe
          title="pdf-preview"
          src={src}
          width="100%"
          height={height}
        />
      )}

      {/* TIFF */}
      {preview.type?.includes("tif") && (
        <div ref={canvasRef} />
      )}

      {/* FALLBACK */}
      {!preview.type && (
        <Box mt={2}>
          <Typography>Preview not supported</Typography>
          <Button variant="contained" href={src} target="_blank">
            Download File
          </Button>
        </Box>
      )}
    </Box>
  );
}
